import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { SrcPipe } from '../../src.pipe';

@Component({
  selector: 'app-file-preview',
  templateUrl: './file-preview.component.html',
  styleUrls: ['./file-preview.component.less']
})
export class FilePreviewComponent implements OnInit {
  _url: any;
  maxHeight:number;
  @Input() get url() {
    return this._url;

  }

  set url(v) {
    this._url = this.sanitizer.bypassSecurityTrustResourceUrl(`${v}`);
  }

  constructor(private sanitizer: DomSanitizer) {
    this.maxHeight=document.body.offsetHeight-190;
    //https://view.officeapps.live.com/op/view.aspx?src=
  }

  ngOnInit(): void {

  }

}
